import { render, staticRenderFns } from "./SbppsLCPrint.vue?vue&type=template&id=52682df6&scoped=true&"
import script from "./SbppsLCPrint.vue?vue&type=script&lang=js&"
export * from "./SbppsLCPrint.vue?vue&type=script&lang=js&"
import style0 from "./SbppsLCPrint.vue?vue&type=style&index=0&id=52682df6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52682df6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VCol,VIcon,VRow,VSimpleTable})
